import React, { useEffect, useState } from 'react'
import SosSearchDrawer from "../Summary/Summaries/Components/SummaryHeader/Components/SosSearchDrawer"
import { useAppContext } from '../../../../../context/AppContext'
import { requestReports, getSingleAvailableSummary } from 'actions/applicants'
import strings from 'strings'
import Button from 'components/shared/Button'
import SosFilings from '../Summary/Summaries/Components/SosFilings/SosFilings'
import { Alert } from '@material-ui/lab'
import Loader from 'components/shared/Loader'
import './index.scss'
import { getBusinessReportSummary, updateSummary } from '../../../../../actions/applicants'
import { useDispatch } from 'react-redux'

const SosSearchInTab = (props) => {
    const {creditCosts, updateSummaryCard} = props;
    const { isDemoMode } = useAppContext()
    const [openSearchDrawer, setOpenSearchDrawer] = useState(false)
    const [loading, setLoading] = useState(true)
    const [status, setStatus] = useState({})
    const [summaryInfo, setSummaryInfo] = useState()
    const dispatch = useDispatch()


    const pathname = window.location.pathname;
    const applicantId = pathname.split('/')[2];
    const reportId = "sos-business"
    const reportType = "SOS"

    const summaryStrings = strings.APPLICANT.SUMMARY

    const requestDecision = () => {
        setLoading(true)
        requestReports(applicantId, { reportType }, isDemoMode)()
            .then((res) => {
                getSosSummaryInfo()
            })
            .catch(() => { setLoading(false) })
    }

    const getSummaryInfo = () => {
        return getBusinessReportSummary(applicantId, reportType, isDemoMode)()
            .then((res) => {
                setSummaryInfo(res || []);
                updateSummary()(dispatch)
            })
    }


    const getSosSummaryInfo = (tryNumber = 0) => {
        const params = { reportType }
        const checkStatus = () => {
            getSingleAvailableSummary(applicantId, params)()
                .then((res) => {
                    const reportData = res?.[0]
                    const reportStatus = reportData?.status?.value

                    if (reportData && reportStatus !== 'WAITING_RESPONSE') {
                        setStatus(reportData?.status || {})
                        setLoading(false)
                    } else if (tryNumber < 12) {  // Add a max retry limit (e.g., 60 seconds total)
                        setTimeout(() => {
                            getSosSummaryInfo(tryNumber + 1)
                        }, 5000)
                    } else {
                        setLoading(false)  // Give up after max retries
                    }
                })
                .catch(() => {
                    setLoading(false)
                })
        }

        // First call is immediate, subsequent calls have the 5s delay
        if (tryNumber === 0) {
            checkStatus()
        } else {
            setTimeout(checkStatus, 5000)
        }
    }



    useEffect(() => {
        if (status?.value === 'FOUND') {
            getSummaryInfo();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status]);

    useEffect(() => {
        getSosSummaryInfo()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Listen for refresh event from SosSearch when a record is saved
    useEffect(() => {
        const handleRefresh = () => {
            getSummaryInfo()
        }

        window.addEventListener('refreshSavedRecords', handleRefresh)
        return () => window.removeEventListener('refreshSavedRecords', handleRefresh)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div id="sos-search-in-tab">
            <div className="uccContainer d-flex justify-content-between align-items-center">
                <div className='uccTitleContainer w-50'>
                    <h5 className='mb-2'>{summaryStrings.SECRETARY_OF_STATE}</h5>
                </div>

                <div className="top-actions">
                    <Button
                        variant="outlined"
                        color="primary"
                        className='summaryHeaderButton ml-3'
                        onClick={() => setOpenSearchDrawer(true)}
                        loading={loading}
                        id={'view-more-' + reportId}
                    >
                        {summaryStrings.VIEW_MORE}
                    </Button>
                </div>
            </div>

            {loading ?
                <div className='p-3'>
                    <Loader />
                </div> :

                summaryInfo?.tabsData ?
                    <div className='pb-3 pl-3 pr-3'>
                        <SosFilings tabsData={summaryInfo?.tabsData} />
                    </div> :
                    <div className='pl-3 pr-3'>
                        <Alert severity={"info"}>
                            {summaryStrings.NO_RESULTS_YET}
                        </Alert>
                    </div>
            }
            <SosSearchDrawer creditCosts={creditCosts} open={openSearchDrawer} applicantId={applicantId} onClose={() => setOpenSearchDrawer(false)} requestDecision={requestDecision} updateSummaryCard={updateSummaryCard} />

        </div>
    )
}

export default SosSearchInTab